import { Button, Drawer, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

const DeliveryDetails = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const [total, setTotal] = useState(0);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["deliverysaverawproduct", "product"],
      sorter: (a, b) =>
        a.deliverysaverawproduct.product - b.deliverysaverawproduct.product,
    },
    // {
    //   title: "Description",
    //   dataIndex: ["deliverysaverawproduct", "description"],
    //   sorter: (a, b) =>
    //     a.deliverysaverawproduct.description -
    //     b.deliverysaverawproduct.description,
    // },
    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
    },
    {
      title: "Unit",
      dataIndex: ["deliverysaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
    },
    {
      title: "Qty * Price",
      // dataIndex: "quantity",
      align: "right",
      render: (text, record) => (
        <>
          {text.quantity} * {text.deliverysaverawproduct.purchase_price}
        </>
      ),
    },
    {
      title: "Amount",
      // dataIndex: ["deliverysaverawproduct", "msrp"],
      align: "right",
      render: (text, record) => (
        <>
          {parseFloat(
            parseFloat(text.quantity) *
              parseFloat(text.deliverysaverawproduct.purchase_price)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total +=
        parseFloat(data[i].deliverysaverawproduct.purchase_price) *
        parseFloat(data[i].quantity);
    }
    return total;
  };

  const getMerchantDeliveryDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      dr_number: selectedData !== null ? selectedData.dr_number : "",
    };
    axios
      .get("user/commissary/spec-delivery-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        // console.log("DATA", data);
        setOrderDetailsList({ data, ready: true });
        setTotal(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  useEffect(() => {
    getMerchantDeliveryDetails();
  }, [getMerchantDeliveryDetails]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Delivery Order Details"
      width={window.innerWidth > 500 ? 600 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <div
          style={{ overflowX: "auto", padding: paddingPrint }}
          ref={componentRef}
        >
          {displayDetailsPrint && (
            <Typography.Title level={4} style={{ marginBottom: 15 }}>
              {selectedData.dr_number} - Delivery Receipt
            </Typography.Title>
          )}
          <Typography level={4}>
            Created P.O:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].po_number}
            </b>
          </Typography>
          <Typography level={4}>
            Created Ref.#:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].po_number_id}
            </b>
          </Typography>
          <Typography level={4}>
            Delivery #:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].dr_number}
            </b>
          </Typography>
          <Typography level={4}>
            Delivery Date:{" "}
            <b>
              {orderDetailsList.data.length > 0 &&
                moment(
                  new Date(orderDetailsList.data[0].dr_date),
                  "YYYY-MM-DD"
                ).format("MMMM DD, YYYY")}
            </b>
          </Typography>
          <Table
            {...tableProps}
            // pagination={{
            //   position: ["bottomRight"],
            // }}
            pagination={false}
            columns={tableColumns}
            dataSource={
              orderDetailsList.data.length > 0 ? orderDetailsList.data : []
            }
            scroll={scroll}
            rowKey={(record) => record.raw_id}
            footer={() => (
              <div style={{ display: "flex" }}>
                <div style={{ flexGrow: 1 }} />
                Total:{" "}
                {total.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </div>
            )}
          />
        </div>
      )}

      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ flexGrow: 1 }} />
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
          >
            Print
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default DeliveryDetails;
